<template>
  <div class="card mb-25 border-0 rounded-0 bg-white add-user-card">
    <div class="billetage-form container p-15 p-md-40">
      <h5 class="fw-bold text-black mb-15 mb-md-25">{{ title }}</h5>
      <Form ref="billetageForm" @submit="addOperation" :validation-schema="operationSchema">
        <div class="div row">
          <div class="div col-md-12">
            <div class="div row">
              <div class="div col-md-6">
                <div class="div form-group mb-12">
                  <div class="div d-flex align-items-center justify-content-between">
                    <label class="label d-block text-black fw-semibold mb-5">
                      Bénéficiaire<span class="span text-danger">*</span>
                    </label>
                  </div>
                  <Field name="beneficiaire" class="form-control compact-input "/>
                  <ErrorMessage name="beneficiaire" class="text-danger" />
                </div>
              </div>
              <div class="div col-md-6">
                <div class="div form-group mb-12">
                  <label class="label d-block text-black fw-semibold mb-5">
                    Autre Informations
                  </label>
                   <Field name=" autreInformation" class="form-control compact-input "/>
                  <ErrorMessage name=" autreInformation" class="text-danger" />
                </div>
              </div>
            </div>
            
            <!-- Titre centré pour la section Conversion de Billets -->
            <div class="text-center mb-4 mt-3">
              <h4 class="fw-bold text-primary">Conversion de Billets</h4>
            </div>

            <div class="div row gx-4">
              <!-- SORTIES à gauche -->
              <div class="div col-md-6 mb-md-12">
                <div class="div border mb-5" style="border-color: #a40a0a !important;">
                  <div class="div row fw-bold py-2" style="background-color: #a40a0a">
                    <div class="div col-md-7">
                      <h3 class="h3 fs-4 text-white">SORTIES</h3>
                    </div>
                    <div class="div col-md-5">
                      <h3 class="fs-5 text-white" style="text-align: end;font-weight: bold;" v-if="montantTotalSortie"> {{ (montantTotalSortie) }} Fcfa</h3>
                    </div>
                  </div>
                  <div class="div px-3">
                    <div class="div row mt-2">
                      <div class="div col-md-4"><label class="label fw-semibold">Monnaie</label></div>
                      <div class="div col-md-4"><label class="label fw-semibold">Quantité</label></div>
                      <div class="div col-md-4"><label class="label fw-semibold">Montant</label></div>
                    </div>
                    <hr class="hr mt-0" />
                    <template v-for="(billetage, index) in billetageSortieList" :key="index">
                      <div class="div container-tight m-0 py-1">
                        <div class="div row align-items-center">
                          <div class="div col-md-4 px-1">
                            <input
                              name="monnaie"
                              v-model="billetage.libelle"
                              readonly
                              class="form-control compact-input"
                              placeholder="Monnaie"
                            />
                          </div>
                          <div class="div col-md-4 px-1">
                            <Field
                              :name="`billetageSortieList[${index}].qteBillet`"
                              type="number"
                              min="0"
                              v-model="billetage.qteBillet"
                              @input="event => handleBilletageInput(event, billetage, 'sortie')"
                              @keypress="restrictInput($event)"
                              class="form-control compact-input"
                              placeholder="Qté"
                            />
                            <ErrorMessage :name="`billetageSortieList[${index}].qteBillet`" class="text-danger compact-error" />
                          </div>
                          <div class="div col-md-4 px-1">
                            <input
                              type="text"
                              v-model="billetage.montant"
                              readonly
                              placeholder="Montant"
                              class="form-control compact-input"
                            />
                          </div>
                        </div>
                      </div>
                    </template>
                  </div>
                </div>
              </div>
 
              <!-- ENTRÉES à droite -->
              <div class="div col-md-6 mb-md-12">
                <div class="div border mb-5" style="border-color: #0a59a4 !important;">
                  <div class="div row fw-bold py-2" style="background-color: #0a59a4">
                    <div class="div col-md-7">
                      <h3 class="h3 fs-4 text-white">ENTRÉES </h3>
                    </div>
                    <div class="col-md-5">
                      <h3 class="fs-5 text-white" style="text-align: end;font-weight: bold;" v-if="montantTotalEncaissement"> {{ (montantTotalEncaissement) }} Fcfa</h3>
                    </div>
                  </div>
                  <div class="div px-3">
                    <div class="div row mt-2">
                      <div class="div col-md-4"><label class="label fw-semibold">Monnaie</label></div>
                      <div class="div col-md-4"><label class="label fw-semibold">Quantité</label></div>
                      <div class="div col-md-4"><label class="label fw-semibold">Montant</label></div>
                    </div>
                    <hr class="hr mt-0" />
                    <template v-for="(billetage, index) in billetageList" :key="index">
                      <div class="div container-tight m-0 py-1">
                        <div class="div row align-items-center">
                          <div class="div col-md-4 px-1">
                            <input
                              name="monnaie"
                              v-model="billetage.libelle"
                              readonly
                              class="form-control compact-input"
                              placeholder="Monnaie"
                            />
                          </div>
                          <div class="div col-md-4 px-1">
                            <Field
                              :name="`billetageList[${index}].qteBillet`"
                              type="number"
                              min="0"
                              v-model="billetage.qteBillet"
                              @input="event => handleBilletageInput(event, billetage, 'encaissement')"
                              @keypress="restrictInput($event)"
                              class="form-control compact-input"
                              placeholder="Qté"
                            />
                            <ErrorMessage :name="`billetageList[${index}].qteBillet`" class="text-danger compact-error" />
                          </div>
                          <div class="div col-md-4 px-1">
                            <input
                              type="text"
                              v-model="billetage.montant"
                              readonly
                              placeholder="Montant"
                              class="form-control compact-input"
                            />
                          </div>
                        </div>
                      </div>
                    </template>
                  </div>
                </div>
              </div>
            </div>
 
            <div class="alert alert-danger" role="alert" v-if="montantError">
              {{ montantError }}
            </div>
 
            <div class="div mb-3 mt-1">
              <button type="submit" class="btn btn-primary top-end" :disabled="montantError">Envoyer</button>
              <button type="button" class="btn btn-danger mx-1" @click="cancelOperation">Annuler</button>
            </div>
          </div>
        </div>
      </Form>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, reactive, onMounted, computed } from 'vue';
import { Form, Field, ErrorMessage, useForm } from 'vee-validate';
import * as Yup from 'yup';
import { useRouter } from 'vue-router';
import { error, monSwal, success } from '@/utils/utils';
import ApiService from '@/services/ApiService';

interface BilletageForm {
  libelle: string;
  qteBillet: number;
  montant: number;
  monnaie: number;
  valueAct: number;
}

export default defineComponent({
  name: "ConversionMonnaie",
  components: { Form, Field, ErrorMessage },
  props: {
    title: { type: String, required: true },
  },
  setup(props) {
    const router = useRouter();
    const billetageList = reactive<BilletageForm[]>([]);
    const billetageSortieList = reactive<BilletageForm[]>([]);
    const monnaieList = ref<any[]>([]);
    const montantTotalEncaissement = ref<number | null>(null);
    const montantTotalSortie = ref<number | null>(null);
    const typeOperationId = ref<number>(1);
    const billetageForm = ref<InstanceType<typeof Form> | null>(null);
    const { resetForm } = useForm();
    const beneficiaire = ref<string>('');
    const autreInformation = ref<string>('');
    const isLoading = ref<boolean>(false);

    const montantError = computed(() => {
      const encaissement = montantTotalEncaissement.value || 0;
      const sortie = montantTotalSortie.value || 0;

      if (encaissement !== sortie) {
        return `Les montants ne sont pas équilibrés : Encaissement (${encaissement} Fcfa) doit être égal à Sortie (${sortie} Fcfa).`;
      }

      return null;
    });

    const operationSchema = Yup.object({
      beneficiaire: Yup.string().required('Le bénéficiaire est obligatoire'),
      autreInformation: Yup.string().notRequired(),
      billetageList: Yup.array().of(
        Yup.object().shape({
          qteBillet: Yup.number()
            .typeError('La quantité doit être un nombre')
            .required('La quantité est obligatoire')
            .integer('La quantité doit être un entier')
            .min(0, 'La quantité ne peut pas être négative'),
        })
      ),
      billetageSortieList: Yup.array().of(
        Yup.object().shape({
          qteBillet: Yup.number()
            .typeError('La quantité doit être un nombre')
            .required('La quantité est obligatoire')
            .integer('La quantité doit être un entier')
            .min(0, ' giocato ne peut pas être négative'),
        })
      ),
    });

    const getAllMonnaies = async () => {
      try {
        const res = await ApiService.get("/all/monnaies");
        monnaieList.value = res.data.data.data;
        billetageList.splice(0, billetageList.length);
        billetageSortieList.splice(0, billetageSortieList.length);
        monnaieList.value.forEach((element) => {
          const billetage = {
            libelle: element.libelle,
            montant: 0,
            valueAct: element.valeur,
            monnaie: element.id,
            qteBillet: 0,
          };
          billetageList.push({ ...billetage });
          billetageSortieList.push({ ...billetage });
        });
      } catch (err) {
        console.error("Erreur lors de la récupération des monna interessato:", err);
        error("Erreur lors de la récupération des monnaies");
      }
    };

    const handleBilletageInput = (event: Event, billetage: BilletageForm, type: 'encaissement' | 'sortie') => {
      const newValue = Number((event.target as HTMLInputElement).value);
      billetage.qteBillet = isNaN(newValue) || newValue < 0 ? 0 : newValue;
      updateMontant(billetage, type);
    };

    const updateMontant = (billetage: BilletageForm, type: 'encaissement' | 'sortie') => {
      billetage.montant = billetage.qteBillet * billetage.valueAct || 0;
      if (type === 'encaissement') {
        calculateTotalEncaissement();
      } else {
        calculateTotalSortie();
      }
    };

    const calculateTotalEncaissement = () => {
      const total = billetageList.reduce((total, billetage) => {
        return total + (billetage.montant || 0);
      }, 0);
      montantTotalEncaissement.value = total || null;
    };

    const calculateTotalSortie = () => {
      const total = billetageSortieList.reduce((total, billetage) => {
        return total + (billetage.montant || 0);
      }, 0);
      montantTotalSortie.value = total || null;
    };

    const cancelOperation = async () => {
      const confirmed = await monSwal(
        'Voulez-vous vraiment annuler l’opération ?',
        'Confirmer',
        'btn btn-primary',
        'Annuler',
        'L’opération a été annulée !'
      );
      if (confirmed) {
        if (billetageForm.value) {
          resetForm();
        } else {
          console.warn('billetageForm n’est pas défini');
        }
        billetageList.length = 0;
        billetageSortieList.length = 0;
        await getAllMonnaies();
        router.push('/ajouter-encaissement');
      }
    };

    const addOperation = async (values: any, { resetForm }: any) => {
      if (montantError.value) {
        error(montantError.value);
        return;
      }

      isLoading.value = true;
      try {
        const payload = {
          beneficiaire: values.beneficiaire,
          autreInformation: values.autreInformation,
          typeOperationId: typeOperationId.value,
          billetagesEncaissement: billetageList,
          montantTotalEncaissement: montantTotalEncaissement.value,
          billetagesSortie: billetageSortieList,
          montantTotalSortie: montantTotalSortie.value,
          date: new Date(),
          type: 'Encaissement',
        };

        await ApiService.post("conversion/operations", payload);
        console.log("enoyee",payload);
        success(`Conversion de ${montantTotalEncaissement.value} Fcfa enregistrée avec succès !`);
        resetForm();
        billetageList.length = 0;
        billetageSortieList.length = 0;
        await getAllMonnaies();
        beneficiaire.value = '';
        autreInformation.value = '';
      } catch (err: any) {
        const errorMessage = err.response?.data?.message || "Erreur lors de l'ajout de l'opération";
        error(errorMessage);
      } finally {
        isLoading.value = false;
      }
    };

    onMounted(() => {
      getAllMonnaies();
    });

    const restrictInput = (event: KeyboardEvent) => {
      if (!/^[0-9]*$/.test(event.key) && event.key !== 'Backspace') {
        event.preventDefault();
      }
    };

    return {
      billetageList,
      beneficiaire,
      autreInformation,
      billetageSortieList,
      montantTotalEncaissement,
      montantTotalSortie,
      operationSchema,
      restrictInput,
      handleBilletageInput,
      addOperation,
      montantError,
      cancelOperation,
      billetageForm,
      isLoading,
    };
  },
});
</script>

<style scoped>
.btn-sm {
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
}
 
.montant-total {
  text-align: left;
  font-weight: bold;
  font-size: 1rem;
  margin-top: 8px;
}
 
.text-danger {
  font-size: 0.75rem;
  color: #dc3545;
}
 
.compact-input {
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  height: 30px;
}
 
.compact-error {
  font-size: 0.75rem;
  margin-top: 2px;
}
 
.container-tight {
  margin: 0;
  padding: 2px 0;
}
</style>
 